module.exports = __webpack_public_path__ + "media/standardized_tests/sticky_02-d76a824a.jpg";